import { register } from 'register-service-worker'

// The actual registration only happens in production builds
if (process.env.NODE_ENV === 'production') {
  console.log('Attempting to register Service Worker...')

  register(process.env.SERVICE_WORKER_FILE, {
    ready() {
      console.log('App is being served from cache by a service worker.')
    },
    registered(registration) {
      console.log('Service worker has been registered.', registration)
    },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    updatefound() {
      console.log('New content is downloading.')
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updated(registration) {
      console.log('New content is available; please refresh.')
      // Optional: We can add logic here later to show a "Refresh App" button
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    },
  })
}
